<template>
    <div class="user-test-paper">
        <div v-if="list.length > 0">
            <TestItem
                v-for="(item, index) in list"
                :key="index"
                :item="item"
                :index="index + 1"
            ></TestItem>
        </div>
        <el-button v-if="list.length > 0" size="mini" class="user-test-btn" type="primary" @click="submitPaper">提交评卷</el-button>
        <EmptyPage v-if="list.length === 0"></EmptyPage>
    </div>
</template>
<script>
import TestItem from './components/testItem.vue'
import EmptyPage from '@/components/emptyPage'

export default {
    name: 'UserTestPaper',
    components: { TestItem, EmptyPage },
    data() {
        return {
            list: []
        }
    },
    activated() {
        this.examMarkingDetail()
    },
    methods: {
        examMarkingDetail() {
            this.$api.user.exam.examMarkingDetail({
                examDataUserLogId: this.$route.query.examDataUserLogId
            }).then(res => {
                this.list = res.data
            })
        },
        submitPaper() {
            let _params = []
            for (let  item  of this.list) {

                let a = 1
                if (!item.personNewScore) {
                    this.$message({ type: 'warning', message: '第' + (this.list.indexOf(item)+a)+ '题请评分' });
                    return
                }
                 let personNewScore = item.personNewScore - 0
                 let score = item.score - 0
                 if (personNewScore < 0 || personNewScore > score  ) {
                    this.$message({ type: 'warning', message: '第' + (this.list.indexOf(item)+a) + '题评分不在范围内请重新评分' });
                    return
                }
                _params.push({
                    examDataUserLogId: this.$route.query.examDataUserLogId,
                    examId: item.examDataId,
                    examPaperId: item.examPaperId,
                    examUserId: this.$route.query.examUserId,
                    originalScore: item.score,
                    score: item.personNewScore ? item.personNewScore : 0,
                    subjectId: item.subjectId
                })
            }
            this.$confirm('确认提交评卷?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.submitData(_params)
            })
            
            
        },
        submitData(params) {
            this.$api.user.exam.markingOperation(params).then(res => {
                this.$message({ type: 'success', message: '评卷成功' });
                this.$router.back();
            })
        },
    }
}
</script>
<style lang="scss" scoped>
@import '../../styles/variables.scss';

.user-test-paper {
    white-space:pre-wrap;
    padding: .2rem .15rem;
    margin: .2rem 0;
    box-shadow: 0px 2px 10px 0px rgba($color: $font__color_000, $alpha: 0.05);
    border-radius: 5px;
    background: $white_bg_color;
    .el-button {
        width: .9rem;
    }
}
</style>